<script>
import baseList from '@/views/components/base/baseList.vue'
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "ordersType",
        key: "id",
        url: {
          list: `/admin/ordersType/selectDetail`,

        },
      },
      tableCols: [
        {
          title: '商品编号',
          key: 'commodityNumber',
          align: 'center',
          width: 300,
        },
        {
          title: '商品名称',
          key: 'commodityName',
          align: 'center',
          width: 300,
        },
        {
          title: '商品数量',
          key: 'commodityQuantity',
          align: 'center',
          width: 100,
        },
        {
          title: '商品型号',
          key: 'model',
          align: 'center',
          width: 200,
        },
        {
          title: '商品图片',
          key: 'commodityImage',
          align: 'center',
          width: 200,
          viewimage: true,
        },
      ]
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.kv;
    this.id = id;
  },
  methods: {

  },
}
</script>
